import template from './addSubcontractorEmployeeModal.html';
import controller from './addSubcontractorEmployeeModal.controller';

let AddSubcontractorEmployeeComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller,
  size: 'lg',
  windowClass: "hmodal-info animated zoomIn"
};

export default AddSubcontractorEmployeeComponent;



// WEBPACK FOOTER //
// ./client/common/modals/addSubcontractorEmployee/addSubcontractorEmployee.component.js